export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const NetworkContextName = "NETWORK";
export const IS_IN_IFRAME = window.parent !== window;
export const REG_TOKEN_v3_CONTRACT_ADDRESS = process.env.REACT_APP_REGULAR_DOLLARS_CONTRACT_ADDRESS || "";
export const UGLYPOOL_CONTRACT_ADDRESS = process.env.REACT_APP_UGLY_CONTRACT_ADDRESS || "";
export const DAPP_ID = process.env.REACT_APP_DAPP_ID;
export const S3_IMAGES_JPG_URL =
  "https://firebasestorage.googleapis.com/v0/b/nft-collections-2dc2c.appspot.com/o/regulars%2F";
